/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import { AlertCardAlertFragmentDoc } from '../../../alert-cards/src/lib/AlertCard/alertCard.hook'
import * as Types from '../../../graphql/src/lib/graphql/generated/types'
export type VehicleDrawerAlert_HubServiceNotification_Fragment = {
  __typename?: 'HubServiceNotification'
  createdAt: string
  id: string
  notificationType: Types.TaskNotificationType
}

export type VehicleDrawerAlert_IvcTaskNotification_Fragment = {
  __typename?: 'IvcTaskNotification'
  createdAt: string
  id: string
  notificationType: Types.TaskNotificationType
}

export type VehicleDrawerAlert_PassengerAuthentificationFallbackRequestedNotification_Fragment =
  {
    __typename?: 'PassengerAuthentificationFallbackRequestedNotification'
    createdAt: string
    id: string
    notificationType: Types.TaskNotificationType
  }

export type VehicleDrawerAlert_PassengerUnbuckled_Fragment = {
  __typename?: 'PassengerUnbuckled'
  createdAt: string
  id: string
  notificationType: Types.TaskNotificationType
}

export type VehicleDrawerAlert_RoadBlockageTaskNotification_Fragment = {
  __typename?: 'RoadBlockageTaskNotification'
  createdAt: string
  id: string
  notificationType: Types.TaskNotificationType
}

export type VehicleDrawerAlert_ShiftDeviationNotification_Fragment = {
  __typename?: 'ShiftDeviationNotification'
  createdAt: string
  id: string
  notificationType: Types.TaskNotificationType
}

export type VehicleDrawerAlert_StopAccessibilityDownvotedByDrivers_Fragment = {
  __typename?: 'StopAccessibilityDownvotedByDrivers'
  createdAt: string
  id: string
  notificationType: Types.TaskNotificationType
}

export type VehicleDrawerAlert_StopActivationFailedNotification_Fragment = {
  __typename?: 'StopActivationFailedNotification'
  createdAt: string
  id: string
  notificationType: Types.TaskNotificationType
}

export type VehicleDrawerAlert_StopAreaMissingActiveStopsNotification_Fragment =
  {
    __typename?: 'StopAreaMissingActiveStopsNotification'
    createdAt: string
    id: string
    notificationType: Types.TaskNotificationType
  }

export type VehicleDrawerAlert_StopDownVotedByDrivers_Fragment = {
  __typename?: 'StopDownVotedByDrivers'
  createdAt: string
  id: string
  notificationType: Types.TaskNotificationType
}

export type VehicleDrawerAlert_StopPotentiallyUnreachable_Fragment = {
  __typename?: 'StopPotentiallyUnreachable'
  createdAt: string
  id: string
  notificationType: Types.TaskNotificationType
}

export type VehicleDrawerAlert_StopValidationFailed_Fragment = {
  __typename?: 'StopValidationFailed'
  createdAt: string
  id: string
  notificationType: Types.TaskNotificationType
}

export type VehicleDrawerAlert_TimeManagementNotification_Fragment = {
  __typename?: 'TimeManagementNotification'
  createdAt: string
  id: string
  notificationType: Types.TaskNotificationType
}

export type VehicleDrawerAlert_TripPrebookingNoAssignment_Fragment = {
  __typename: 'TripPrebookingNoAssignment'
  createdAt: string
  id: string
  notificationType: Types.TaskNotificationType
  status: Types.TaskNotificationStatus
  rejectionAt: string
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
    backofficeUser: {
      __typename?: 'BackofficeUser'
      id: string
      username: string
    } | null
  } | null
  trip: {
    __typename?: 'Trip'
    id: string
    customerV2: {
      __typename?: 'CustomerV2'
      id: string
      givenName: string | null
      familyName: string | null
      phoneNumber: string | null
    }
    pickup: {
      __typename?: 'TripTransferInformation'
      promisedTime: {
        __typename?: 'DateTimeInterval'
        from: string
        to: string
      }
    }
    seatInfo: { __typename?: 'TripSeatInfo'; wheelchairs: number }
  } | null
  resolved: {
    __typename?: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
  } | null
  pickupStop: {
    __typename?: 'Stop'
    id: string
    names: Partial<Record<'de' | 'en' | 'no', string>>
    address: {
      __typename?: 'StopAddress'
      street: string | null
      houseNumber: string | null
      postalCode: string | null
      city: string | null
    }
    routingLocation: {
      __typename?: 'Location'
      latitude: number
      longitude: number
    }
  } | null
  dropoffStop: {
    __typename?: 'Stop'
    id: string
    names: Partial<Record<'de' | 'en' | 'no', string>>
    address: {
      __typename?: 'StopAddress'
      street: string | null
      houseNumber: string | null
      postalCode: string | null
      city: string | null
    }
    routingLocation: {
      __typename?: 'Location'
      latitude: number
      longitude: number
    }
  } | null
  stateChanges: Array<{
    __typename: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
    timestamp: string | null
    to: Types.TaskNotificationStatus
    backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export type VehicleDrawerAlert_VehicleAvailabilityNotification_Fragment = {
  __typename?: 'VehicleAvailabilityNotification'
  createdAt: string
  id: string
  notificationType: Types.TaskNotificationType
}

export type VehicleDrawerAlert_VehicleIncidentNotification_Fragment = {
  __typename?: 'VehicleIncidentNotification'
  createdAt: string
  id: string
  notificationType: Types.TaskNotificationType
}

export type VehicleDrawerAlert_VehicleSurveillanceNotification_Fragment = {
  __typename: 'VehicleSurveillanceNotification'
  createdAt: string
  id: string
  notificationType: Types.TaskNotificationType
  status: Types.TaskNotificationStatus
  employee: {
    __typename?: 'Employee'
    id: string
    firstName: string | null
    lastName: string | null
  } | null
  vehicle: {
    __typename?: 'Vehicle'
    id: string
    highVoltageBatteryLevel: number | null
    cruisingRange: number | null
    totalPassengersInVehicle: number | null
    inService: boolean | null
    label: number | null
    licensePlate: string | null
    isSelfDriving: boolean
    hardwareConfiguration: {
      __typename?: 'HardwareConfiguration'
      tablet: { __typename?: 'Tablet'; phoneNumber: string | null } | null
    } | null
    fleet: { __typename?: 'Fleet'; id: string } | null
    lastVehicleInteraction: {
      __typename?: 'VehicleInteraction'
      type: Types.VehicleInteractionType
    } | null
  } | null
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
    backofficeUser: {
      __typename?: 'BackofficeUser'
      id: string
      username: string
    } | null
  } | null
  stateChanges: Array<{
    __typename: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
    timestamp: string | null
    to: Types.TaskNotificationStatus
    backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export type VehicleDrawerAlert_VehicleWaypointAttendance_Fragment = {
  __typename?: 'VehicleWaypointAttendance'
  createdAt: string
  id: string
  notificationType: Types.TaskNotificationType
}

export type VehicleDrawerAlertFragment =
  | VehicleDrawerAlert_HubServiceNotification_Fragment
  | VehicleDrawerAlert_IvcTaskNotification_Fragment
  | VehicleDrawerAlert_PassengerAuthentificationFallbackRequestedNotification_Fragment
  | VehicleDrawerAlert_PassengerUnbuckled_Fragment
  | VehicleDrawerAlert_RoadBlockageTaskNotification_Fragment
  | VehicleDrawerAlert_ShiftDeviationNotification_Fragment
  | VehicleDrawerAlert_StopAccessibilityDownvotedByDrivers_Fragment
  | VehicleDrawerAlert_StopActivationFailedNotification_Fragment
  | VehicleDrawerAlert_StopAreaMissingActiveStopsNotification_Fragment
  | VehicleDrawerAlert_StopDownVotedByDrivers_Fragment
  | VehicleDrawerAlert_StopPotentiallyUnreachable_Fragment
  | VehicleDrawerAlert_StopValidationFailed_Fragment
  | VehicleDrawerAlert_TimeManagementNotification_Fragment
  | VehicleDrawerAlert_TripPrebookingNoAssignment_Fragment
  | VehicleDrawerAlert_VehicleAvailabilityNotification_Fragment
  | VehicleDrawerAlert_VehicleIncidentNotification_Fragment
  | VehicleDrawerAlert_VehicleSurveillanceNotification_Fragment
  | VehicleDrawerAlert_VehicleWaypointAttendance_Fragment

export const VehicleDrawerAlertFragmentDoc = gql`
    fragment VehicleDrawerAlert on TaskNotification {
  createdAt
  ...AlertCardAlert
}
    ${AlertCardAlertFragmentDoc}`
